import { useMemo } from 'react'
import { Medication } from 'types/PrivateData/MedicalHistory/Medication'
import { parseMedicationDate } from 'util/patient'
import ItemDetailsModalValue from './ItemDetailsModalValue'
import Modal from '@ui-components-3/ui/lib/components/Modal'
import { medicationStatusesMap } from 'schemas/MedicalHistory'
import User from 'singletons/User'

type MedicationDetailsModalProps = {
  medication: Medication | null
  onClose: () => void
}

const MedicationDetailsModal = ({ medication, onClose }: MedicationDetailsModalProps) => {
  const { name, strengthAndUnit, unit, startDate, endDate, direction, status, discontinuedReason } = medication || {}

  const [displayStartDate, displayEndDate] = useMemo(
    () => [startDate, endDate].map((d) => parseMedicationDate(d)),
    [startDate, endDate],
  )

  if (!medication) {
    return null
  }

  return (
    <Modal label="Medication Details" opened footerVariant="right" onClose={onClose}>
      <div className="flex w-full flex-col gap-4">
        <ItemDetailsModalValue label="Medication" value={name} />
        <div className="flex items-start gap-4">
          <ItemDetailsModalValue label="Strength*" value={strengthAndUnit} />
          <ItemDetailsModalValue label="Dispense Unit*" value={unit} />
        </div>
        <div className="flex items-start gap-4">
          <ItemDetailsModalValue label="Start Date" value={displayStartDate} />
          <ItemDetailsModalValue label="End Date" value={displayEndDate} />
        </div>
        <ItemDetailsModalValue label="Direction" value={direction} />
        <div className="flex items-start gap-4">
          <ItemDetailsModalValue label="Status" value={status} />
          {status === medicationStatusesMap.Discontinued && User.isMedicationSafetyPhase2FlagEnabled && (
            <ItemDetailsModalValue label="Discontinued Reasoning" value={discontinuedReason} />
          )}
        </div>
      </div>
    </Modal>
  )
}

export default MedicationDetailsModal
